import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

class BasicCheckbox extends React.Component {
  static propTypes = {
    touched: PropTypes.any,
    errors: PropTypes.any,
    handleChange: PropTypes.any,
    handleBlur: PropTypes.any,
    values: PropTypes.any,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    help: PropTypes.string,
    noFormGroup: PropTypes.bool,
    allowHTML: PropTypes.bool,
    value: PropTypes.any
  };

  render() {
    const {
      touched,
      errors,
      handleChange,
      handleBlur,
      values,
      name,
      label,
      help,
      noFormGroup,
      allowHTML,
      value
    } = this.props;

    return (
      <div
        className={
          touched[name] && errors[name]
            ? (noFormGroup ? '' : 'form-group m-form__group ') + 'has-danger'
            : noFormGroup
            ? ''
            : 'form-group m-form__group '
        }
      >
        <div className="m-checkbox-list">
          <label className="m-checkbox">
            <input
              type="checkbox"
              name={name}
              id={name}
              onChange={handleChange}
              onBlur={handleBlur}
              checked={values[name]}
              value={value}
            />{' '}
            {allowHTML ? (
              <div dangerouslySetInnerHTML={{ __html: label }} />
            ) : (
              <Trans>{label}</Trans>
            )}
            <span />
          </label>
        </div>
        {help && (
          <span className="m-form__help">
            <Trans>{help}</Trans>
          </span>
        )}
        {touched[name] && errors[name] && (
          <div className="form-control-feedback">
            <Trans>{errors[name]}</Trans>
          </div>
        )}
      </div>
    );
  }
}

export default BasicCheckbox;
